export default "__VITE_ASSET__BHuJoE45__"